import { useState } from "react";
import { ArrowUpRight, Check } from "lucide-react";
import { Kicker, Reveal, scrollToId } from "./Reveal";
import { FARBWELT_COLORS, IMAGES } from "../data/content";

export const Farbwelt = () => {
  const [active, setActive] = useState(FARBWELT_COLORS[2]);

  return (
    <section id="farbwelt" className="py-24 md:py-32 bg-surface border-y border-line" data-testid="farbwelt-section">
      <div className="container-x grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <Reveal className="lg:col-span-7">
          <div className="relative overflow-hidden rounded-xl border border-line" data-testid="color-stage">
            <img
              src={IMAGES.innenraumPreview}
              alt="Raumvorschau – Farbwirkung interaktiv ausprobieren, Manfred Berglar, Malermeister, Olpe"
              loading="lazy"
              className="w-full aspect-[16/10] object-cover"
            />
            <div
              className="absolute inset-0 mix-blend-multiply transition-colors duration-700"
              style={{ backgroundColor: active.hex, opacity: 0.45 }}
            />
            <div className="absolute bottom-5 left-5 md:bottom-7 md:left-7 bg-ink/90 backdrop-blur px-5 py-3.5 rounded-xl border-l-2 border-herald">
              <p className="font-display text-2xl font-semibold text-white leading-none" data-testid="active-color-name">
                {active.name}
              </p>
              <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-herald mt-1.5">{active.hex}</p>
            </div>
          </div>
        </Reveal>
        <div className="lg:col-span-5">
          <Reveal>
            <Kicker>Inspiration</Kicker>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 data-testid="farbwelt-title" className="font-display text-4xl sm:text-5xl font-semibold tracking-tight leading-[1.08] mt-4 text-ink">
              Farbe, präzise <span className="font-fraktur text-golddark">gewählt.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="text-muted leading-relaxed mt-6">
              Sechs Stimmungen, ein Klick – und der Raum wechselt den Ton. Unverbindlich, aber ein guter erster
              Eindruck. Wie Farbe wirklich wirkt, zeigen wir Ihnen mit echten Mustern vor Ort.
            </p>
          </Reveal>
          <Reveal delay={0.22}>
            <div className="grid grid-cols-3 gap-4 mt-8">
              {FARBWELT_COLORS.map((c) => {
                const isActive = active.id === c.id;
                return (
                  <button
                    key={c.id}
                    onClick={() => setActive(c)}
                    data-testid={`color-swatch-${c.id}`}
                    aria-label={`Farbton ${c.name}`}
                    aria-pressed={isActive}
                    className="group flex flex-col gap-2 text-left transition-transform duration-300 hover:-translate-y-1"
                  >
                    <span
                      className={`relative aspect-square w-full rounded-xl border transition-shadow duration-300 ${
                        isActive ? "ring-2 ring-ink ring-offset-2 ring-offset-surface border-ink/40" : "border-line"
                      }`}
                      style={{ backgroundColor: c.hex }}
                    >
                      {isActive && (
                        <span className="absolute inset-0 flex items-center justify-center">
                          <Check size={20} className="text-ink bg-white rounded-full p-0.5" />
                        </span>
                      )}
                    </span>
                    <span className="font-mono text-[10px] uppercase tracking-[0.14em] font-bold text-ink/80">{c.name}</span>
                  </button>
                );
              })}
            </div>
          </Reveal>
          <Reveal delay={0.28}>
            <p className="text-muted leading-relaxed mt-6 text-sm">
              „{active.mood}“
            </p>
            <p className="font-mono text-[10px] uppercase tracking-[0.18em] font-bold text-muted mt-4 flex items-center gap-2">
              <span className="w-2 h-2 rotate-45 bg-gold" aria-hidden="true" />
              Abgestimmt auf Architektur, Licht und Nutzung
            </p>
          </Reveal>
          <Reveal delay={0.34}>
            <button onClick={() => scrollToId("#kontakt")} data-testid="farbwelt-cta" className="btn-primary mt-8">
              Farbberatung anfragen <ArrowUpRight size={16} />
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
